import React, { useEffect } from "react";

import { FallBackSpinner } from "components/common/Spinner/FallBackSpinner/FallbackSpinner";
import { login } from "core/services/auth/auth";

const Login: React.FC = ({}) => {
  useEffect(() => {
    login();
  }, []);

  return <FallBackSpinner />;
};

export { Login };
